<div class="container-fluid mt-3 mb-3 theme">
    <div class="row nowrap mt-4 mb-3" aria-label="breadcrumb">
        <div class="col-lg-9 col-sm-9">
            <div class="d-flex usercontrol">
                <h1>ODI History</h1>

                <ul class="breadcrumbcustom" role="navigation" aria-labelledby="breadcrumb">
                    <li><a routerLink="">Home</a></li>
                    <li><a routerLink="/securities">Securities</a></li>
                    <li><a routerLink="/securities/odi">ODI</a></li>
                </ul>
            </div>
        </div>
        <div *ngIf="entityType == 'MEMBER'" class="col-lg-3 col-sm-3 form-group justify-content-end">
            <button class="btn btn-primary btn-sm full-width" (click)="newRequestSubmission()">(+) Add New
                ODI</button>
        </div>
    </div>
    <div id="accordion" class="mb-1">
        <div class="card">
            <div class="card-header pointer" id="memberheading">
                <h3 data-toggle="collapse" data-target="#collapseFilter" aria-expanded="true"
                    aria-controls="collapseFilter">
                    <i class="fa fa-angle-down pull-right customIcon mr-2"></i>Advanced Search
                </h3>
            </div>
            <div id="collapseFilter" class="collapse show" aria-labelledby="memberheading" data-parent="#accordion">
                <div class="card card-body">
                    <form [formGroup]='reportForm' (ngSubmit)="getSubmittedPNotes()">
                        <div class="row ml-1 mr-1">
                            <div class="col-lg-3 col-md-6 col-sm-6 col-6 form-group">
                                <label>Entity Code</label>
                                <select class="form-control form-control-sm selectpicker" formControlName="entityCode"
                                    title="Select Counter Party" data-live-search="true">
                                    <option value="" disabled>Select Reporting Member</option>
                                    <option *ngFor="let data of entityCodeArray" value="{{data.entityCode}}">
                                        {{data.entityCode +" - "+data.userName}}</option>
                                </select>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-6 form-group">
                                <label>Month</label>
                                <select class="form-control form-control-sm selectpicker" formControlName="month"
                                    title="Select Month">
                                    <option *ngFor="let data of monthArray" value="{{data}}">{{data}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-6 form-group">
                                <label>Year</label>
                                <select class="form-control form-control-sm selectpicker" formControlName="year"
                                    title="Select Year">
                                    <option *ngFor="let data of yearArray" value="{{data}}">{{data}}
                                    </option>
                                </select>
                            </div>
                            <div class="col-lg-3 col-md-6 col-sm-6 col-6 form-group">
                                <label>Status</label>
                                <select class="form-control form-control-sm selectpicker" formControlName="status"
                                    title="Select Status">
                                    <option *ngFor="let data of statusArray" value="{{data}}">{{data}}
                                    </option>
                                </select>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-2 col-md-3 col-sm-4 col-6 form-group">
                                <button class="btn btn-primary btn-sm full-width">Search</button>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-4 col-6 form-group">
                                <button class="btn btn-secondary btn-sm full-width" (click)="reset()">Reset</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

    <div class="card card-body" *ngIf="showDataTable">
        <div class="row clearSearch">
            <button type="button" class="btn btn-cancel btn-sm" (click)="clearSearch()" aria-label="close">
                <svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" fill="currentColor" class="bi bi-x"
                    viewBox="0 0 15 15">
                    <path
                        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z" />
                </svg> Filter</button>
        </div>
        <div class="col-lg-6">
            <div class="row newReload">
                <div class="pl-4 mb-0">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor"
                    class="bi bi-arrow-repeat pointer reload" viewBox="0 0 16 16" (click)="getSubmittedPNotes()">
                    <title>Reload</title>
                    <path
                        d="M11.534 7h3.932a.25.25 0 0 1 .192.41l-1.966 2.36a.25.25 0 0 1-.384 0l-1.966-2.36a.25.25 0 0 1 .192-.41zm-11 2h3.932a.25.25 0 0 0 .192-.41L2.692 6.23a.25.25 0 0 0-.384 0L.342 8.59A.25.25 0 0 0 .534 9z" />
                    <path fill-rule="evenodd"
                        d="M8 3c-1.552 0-2.94.707-3.857 1.818a.5.5 0 1 1-.771-.636A6.002 6.002 0 0 1 13.917 7H12.9A5.002 5.002 0 0 0 8 3zM3.1 9a5.002 5.002 0 0 0 8.757 2.182.5.5 0 1 1 .771.636A6.002 6.002 0 0 1 2.083 9H3.1z" />
                </svg>
                </div>
            </div>
        </div>
        <div class="table-responsive scrollable">
            <table id="pnotesList" class="table common-table table-bordered" datatable [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger">
                <thead>
                    <tr>
                        <th>Sr. No.</th>
                        <th>ODI ID</th>
                        <th *ngIf="this.entityType=='ADMIN'">Entity Code</th>
                        <!-- <th>Entity Code</th> -->
                        <th>Month</th>
                        <th>Year</th>
                        <th>Uploaded Annexure</th>
                        <th>Submitted By</th>
                        <th>Submission Date</th>
                        <th>Checker ID</th>
                        <th>Checker Date </th>
                        <th>Status</th>
                        <th *ngIf="entityType == 'MEMBER'">Delete</th>
                    </tr>
                    <tr class="column-search">
                        <th></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th *ngIf="this.entityType=='ADMIN'"><input type="text" class="form-control form-control-sm" />
                        </th>
                        <!-- <th><input type="text" class="form-control form-control-sm" /></th> -->
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th><input type="text" class="form-control form-control-sm" /></th>
                        <th *ngIf="entityType == 'MEMBER'"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let data of this.pNotesList; let i = index">
                        <td>{{i+1}}
                        </td>
                        <td><a (click)="openExistingSubmission(data.pnotesID)">{{data.pnotesID}}</a></td>
                        <td *ngIf="this.entityType=='ADMIN'">{{data.entityCode}}</td>
                        <!-- <td>{{data.entityCode}}</td> -->
                        <td>{{data.month}}</td>
                        <td>{{data.year}}</td>
                        <!-- <td>{{data.fileName}}</td> -->
                        <td><a (click)="downloadPnoteAnnexureById(data.pnotesID, data.fileName)">{{data.fileName}}</a>
                        </td>
                        <td>{{data.makerId}}</td>
                        <td>{{this.datePipe.transform(data.makerDtm, 'dd-MMM-yyyy HH:mm')}}</td>
                        <td>{{data.checkerId}}</td>
                        <td>{{this.datePipe.transform(data.checkerDtm, 'dd-MMM-yyyy HH:mm')}}</td>
                        <td>{{data.status}}</td>
                        <td *ngIf="entityType == 'MEMBER'">
                            <!-- <div *ngIf="data.status == 'PENDING'"> -->
                            <a *ngIf="data.status == 'SUBMITTED'" (click)="showDeleteModal(data.pnotesID)"><i
                                    class="fa fa-trash pointer" aria-hidden="true"></i></a>
                            <!-- </div> -->
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div class="modal fade" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="rejectModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-body text-center">
                    <h6>Do you want to delete this submission and upload new ODI?</h6>
                    <div class="d-flex justify-content-center mt-3">
                        <div class="col-3"><button type="button" class="btn btn-primary full-width"
                                data-dismiss="modal">No</button></div>
                        <div class="col-3"><button type="button" class="btn btn-secondary full-width"
                                data-dismiss="modal" (click)="deleteSubmission()">Yes</button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal fade" id="deleteResubmitModal" tabindex="-1" role="dialog" aria-labelledby="rejectModalLabel"
        aria-hidden="true">
        <div class="modal-dialog" role="document">
            <div class="modal-content">
                <button type="button" class="close d-flex justify-content-end mr-2" data-dismiss="modal"
                    aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-body text-center">
                    <h6>ODI submission already completed for previous month. Do you want to delete this submission
                        and upload new ODI?</h6>
                    <div class="d-flex justify-content-center mt-3">
                        <div class="col-3"><button type="button" class="btn btn-primary full-width"
                                data-dismiss="modal">No</button></div>
                        <div class="col-3"><button type="button" class="btn btn-secondary full-width"
                                data-dismiss="modal" (click)="deleteReSubmission()">Yes</button></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>